import { apiKeyManager } from '@empiriecom/mybuy-session/ApiKey';

// Must map "no codes" to `undefined`, not `''` - urql's `stringifyVariables` drops
// undefined-valued keys but keeps `''` (as `"coupons":""`), which would fragment the cache
// key between a call with durable codes resolved-empty and a caller that omits the key
// entirely, reintroducing the redundant-fetch problem this merge is meant to fix.
export const csvOrUndefined = (codes: string[]) => codes.join(',') || undefined;

/**
 * Wire format of the `loyaltyCoupons` argument: the codes as CSV, prefixed with the customer's
 * choice in the PAYBACK conflict dialog (`preferDiscounts:CODE1,CODE2`) once one was made. The
 * choice is sent even without stored codes (`preferDiscounts:`), since the conflicting coupons
 * are often eCoupons the backend holds itself - same as the legacy checkout.
 */
export const serializeLoyaltyCoupons = (
  conflictBehavior: string | undefined,
  codes: string[],
): string | undefined =>
  conflictBehavior ? `${conflictBehavior}:${codes.join(',')}` : csvOrUndefined(codes);

/** `loyaltyCoupons` as currently held by the durable code store. */
export const storedLoyaltyCoupons = () =>
  serializeLoyaltyCoupons(
    apiKeyManager.getLoyaltyConflictBehavior(),
    apiKeyManager.getLoyaltyCodes(),
  );

/**
 * The `coupons` and `loyaltyCoupons` arguments as currently held by the durable code store. The
 * checkout BFF is stateless about codes, so every basket read and every basket mutation sends
 * them; a mutation without them answers with a basket calculated without the customer's codes.
 */
export const storedCheckoutCodes = () => ({
  coupons: csvOrUndefined(apiKeyManager.getBonuscodes()),
  loyaltyCoupons: storedLoyaltyCoupons(),
});
